'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-13d783d6.js');
var _commonjsHelpers = require('../../_commonjsHelpers-c3cd37b7.js');

/**
 * build-url - A small library that builds a URL given its components
 * @version v6.0.0
 * @link https://github.com/steverydz/build-url#readme
 * @license MIT
 */

var buildUrl = _commonjsHelpers.createCommonjsModule(function (module, exports) {
(function () {

  var root = this;
  var previousBuildUrl = root.buildUrl;

  var encodedParam = function (param) {
    return param === null ? '' : encodeURIComponent(String(param).trim());
  };

  var buildUrl = function (url, options) {
    var queryString = [];
    var key;
    var builtUrl;
    var caseChange; 
    
    if (options && options.lowerCase) {
        caseChange = !!options.lowerCase;
    } else {
        caseChange = false;
    }

    if (url === null) {
      builtUrl = '';
    } else if (typeof(url) === 'object') {
      builtUrl = '';
      options = url;
    } else {
      builtUrl = url;
    }

    if (options) {
      if (options.path) {
        if(builtUrl && builtUrl[builtUrl.length - 1] === '/') {
          builtUrl = builtUrl.slice(0, -1);
        } 

        var localVar = String(options.path).trim(); 
        if (caseChange) {
          localVar = localVar.toLowerCase();
        }
        if (localVar.indexOf('/') === 0) {
            builtUrl += localVar;
        } else {
          builtUrl += '/' + localVar;
        }
      }

      if (options.queryParams) {
        for (key in options.queryParams) {
          if (options.queryParams.hasOwnProperty(key) && options.queryParams[key] !== void 0) {
            var param;
            if (options.disableCSV && Array.isArray(options.queryParams[key]) && options.queryParams[key].length) {
              for(var i = 0; i < options.queryParams[key].length; i++) {
                param = options.queryParams[key][i];
                queryString.push(key + '=' + encodedParam(param));
              }
            } else {              
              if (caseChange) {
                param = options.queryParams[key].toLowerCase();
              }
              else {
                param = options.queryParams[key];
              }
              queryString.push(key + '=' + encodedParam(param));
            }
          }
        }
        builtUrl += '?' + queryString.join('&');
      }

      if (options.hash) {
        if(caseChange)
            builtUrl += '#' + String(options.hash).trim().toLowerCase();
        else
            builtUrl += '#' + String(options.hash).trim();
      }
    } 
    return builtUrl;
  };

  buildUrl.noConflict = function () {
    root.buildUrl = previousBuildUrl;
    return buildUrl;
  };

  {
    if ( module.exports) {
      exports = module.exports = buildUrl;
    }
    exports.buildUrl = buildUrl;
  }
}).call(_commonjsHelpers.commonjsGlobal);
});

var IMAGESERVICE = {
    CROP: {
        PADDING: 'c_pad',
        LIMIT: 'c_limit',
    },
    FULL_PATH_PREFIX: '/image/upload/',
    FORMAT: {
        PNG: 'f_png',
        WEB_P: 'f_webp',
        E_TRIM: 'e_trim',
    },
};

var getImageSizeInfo = function (screenWidth) {
    var screenHeight = Math.round((screenWidth * 4) / 3);
    var horizontalPadding = Math.round(screenWidth / 12.5);
    var verticalPadding = Math.round(screenHeight / 7.3529411765);
    return {
        padding: {
            top: verticalPadding,
            right: horizontalPadding,
            bottom: verticalPadding,
            left: horizontalPadding,
        },
        size: {
            width: screenWidth,
            height: screenHeight,
        },
    };
};
var calculateImageHeight = function (screenWidth) {
    var screenHeight = Math.round((screenWidth * 4) / 3);
    return screenHeight;
};
var configureSize = function (resizeConfig) {
    var width = resizeConfig.width, height = resizeConfig.height, padding = resizeConfig.padding, quality = resizeConfig.quality, isTrimmed = resizeConfig.isTrimmed, isLimited = resizeConfig.isLimited, paddingSize = resizeConfig.paddingSize, webP = resizeConfig.webP;
    var sizeArray = [];
    var pathString = '';
    if (isTrimmed) {
        pathString += IMAGESERVICE.FORMAT.E_TRIM + "/";
    }
    if (webP) {
        pathString += IMAGESERVICE.FORMAT.WEB_P;
    }
    if (quality && quality <= 90) {
        pathString += "/q_" + quality;
    }
    if (padding) {
        sizeArray.push(IMAGESERVICE.CROP.PADDING);
    }
    if (isLimited) {
        pathString += IMAGESERVICE.CROP.LIMIT + "/";
    }
    if (width) {
        sizeArray.push("w_" + width);
    }
    if (height) {
        sizeArray.push("h_" + height);
    }
    if (paddingSize) {
        sizeArray.push("pd_" + paddingSize.top + "_" + paddingSize.right + "_" + paddingSize.bottom + "_" + paddingSize.left);
    }
    if (sizeArray.length > 0) {
        return pathString + "/" + sizeArray.join(',');
    }
    return "" + pathString;
};
var preFormatImage = function (urlpath, staticHost, resizeConfig) {
    if (urlpath === '') {
        return '';
    }
    var fullPath = IMAGESERVICE.FULL_PATH_PREFIX;
    fullPath += configureSize(resizeConfig);
    fullPath += "/" + urlpath;
    fullPath = fullPath.replace(/\/\//g, '/');
    return buildUrl(staticHost, { path: fullPath });
};
var formatImage = function (_a) {
    var src = _a.src, imageWidth = _a.imageWidth, imageHeight = _a.imageHeight, _b = _a.removeText, removeText = _b === void 0 ? false : _b, quality = _a.quality, paddingSize = _a.paddingSize, staticCmsHost = _a.staticCmsHost, _c = _a.padding, padding = _c === void 0 ? false : _c, _d = _a.isTrimmed, isTrimmed = _d === void 0 ? false : _d;
    var resizeConfig = tslib_es6.__assign(tslib_es6.__assign(tslib_es6.__assign(tslib_es6.__assign(tslib_es6.__assign({}, (imageWidth ? { width: imageWidth } : {})), (imageHeight ? { height: imageHeight } : {})), (quality ? { quality: quality } : {})), (paddingSize ? { paddingSize: paddingSize } : {})), { removeText: removeText,
        padding: padding,
        isTrimmed: isTrimmed });
    var webpSrc = preFormatImage(src, staticCmsHost, tslib_es6.__assign(tslib_es6.__assign({}, resizeConfig), { webP: true }));
    var jpegSrc = preFormatImage(src, staticCmsHost, resizeConfig);
    return { webpSrc: webpSrc, jpegSrc: jpegSrc };
};

exports.calculateImageHeight = calculateImageHeight;
exports.formatImage = formatImage;
exports.getImageSizeInfo = getImageSizeInfo;
exports.preFormatImage = preFormatImage;
//# sourceMappingURL=index.js.map
